export default __webpack_public_path__ + "static/Lucky Leasing_logo-75e9bf023db1d9650277a0a5fc4bcfdc.png";